import tseInstance from '../instance'

const getTseFonData = () => {
	return tseInstance.get('/company/tse/fon')
}

export default getTseFonData
